module.exports = __webpack_public_path__ + "img/NT.2a74cb50.png";